"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationPopover = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../gen-src/icons");
var LabelHelpers_1 = require("../LabelHelpers");
var Styles_1 = require("../Styles");
var LabelAssetContent_1 = require("../shared/LabelAssetContent");
var LabelPopoverDetail_1 = require("../shared/LabelPopoverDetail");
function CertificationNonInteractiveIcon() {
    return (react_1.default.createElement(icons_1.SvgCertifiedIconDefault, null));
}
function RenderAnchoredAssetsCertifications(_a) {
    var anchored = _a.anchored, props = __rest(_a, ["anchored"]);
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    if (!(anchored === null || anchored === void 0 ? void 0 : anchored.labels) || (anchored === null || anchored === void 0 ? void 0 : anchored.labels.length) < 1) {
        return null;
    }
    var _b = props.content, contentName = _b.contentName, contentType = _b.contentType, contentUrl = _b.contentUrl, remoteType = _b.remoteType;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, (0, LabelAssetContent_1.onThisAssetMessage)(contentType)),
        react_1.default.createElement(Styles_1.LabelAssetGroupDiv, null,
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { assetName: contentName !== null && contentName !== void 0 ? contentName : null, assetType: contentType !== null && contentType !== void 0 ? contentType : null, assetUrl: linksDisabled ? null : (contentUrl !== null && contentUrl !== void 0 ? contentUrl : null), remoteType: remoteType !== null && remoteType !== void 0 ? remoteType : undefined }),
            react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                react_1.default.createElement(RenderCertifications, { assetName: contentName !== null && contentName !== void 0 ? contentName : null, certifications: anchored === null || anchored === void 0 ? void 0 : anchored.labels })))));
}
function RenderCertifications(props) {
    var category = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext).category;
    var assetName = props.assetName, certifications = props.certifications;
    return (react_1.default.createElement(react_1.default.Fragment, { key: props.keyIndex }, certifications.map(function (i, index) {
        return react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement("span", { style: { display: 'flex', } },
                react_1.default.createElement(Styles_1.CertificationIconWrapperStyle, null,
                    react_1.default.createElement(CertificationNonInteractiveIcon, null)),
                react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAuthorElement, __assign({}, i, { category: category }))),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailDateElement, __assign({}, i)),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailMessageElement, __assign({}, i, { assetName: assetName })));
    })));
}
function CertificationAnchoredSection(_a) {
    var anchored = _a.anchored, props = __rest(_a, ["anchored"]);
    if (!anchored || anchored.labels.length < 1) {
        return null;
    }
    return RenderAnchoredAssetsCertifications(__assign({ anchored: anchored }, props));
}
function CertificationParentedSection(_a) {
    var parented = _a.parented;
    if (!parented || parented.labels.length < 1) {
        return null;
    }
    var copy = parented.labels.map(function (i) { return i; });
    var labelsMap = (0, LabelHelpers_1.groupBy)(copy, function (i) { var _a, _b; return (_b = (_a = i.content) === null || _a === void 0 ? void 0 : _a.contentId) !== null && _b !== void 0 ? _b : ''; });
    var groupedAssetLabels = [];
    labelsMap.forEach(function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return groupedAssetLabels.push({
            subjectArea: (_b = (_a = value[0].content) === null || _a === void 0 ? void 0 : _a.subjectArea) !== null && _b !== void 0 ? _b : null,
            assetName: (_d = (_c = value[0].content) === null || _c === void 0 ? void 0 : _c.contentName) !== null && _d !== void 0 ? _d : null,
            assetType: (_f = (_e = value[0].content) === null || _e === void 0 ? void 0 : _e.contentType) !== null && _f !== void 0 ? _f : null,
            assetUrl: (_h = (_g = value[0].content) === null || _g === void 0 ? void 0 : _g.contentUrl) !== null && _h !== void 0 ? _h : null,
            remoteType: (_k = (_j = value[0].content) === null || _j === void 0 ? void 0 : _j.remoteType) !== null && _k !== void 0 ? _k : undefined,
            category: 'certification',
            labels: value
        });
    });
    return (react_1.default.createElement(Styles_1.LabelAssetChildGroupDiv, null, groupedAssetLabels.map(function (c, i) {
        var _a;
        return (react_1.default.createElement(Styles_1.LabelAssetGroupDiv, { key: i },
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { assetName: c.assetName, assetType: c.assetType, assetUrl: c.assetUrl, remoteType: c.remoteType }),
            react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                react_1.default.createElement(RenderCertifications, { assetName: (_a = c.assetName) !== null && _a !== void 0 ? _a : null, certifications: c.labels, keyIndex: "".concat(i) }))));
    })));
}
function CertificationPopover(props) {
    return (props.anchored ? react_1.default.createElement(CertificationAnchoredSection, __assign({}, props)) : react_1.default.createElement(CertificationParentedSection, __assign({}, props)));
}
exports.CertificationPopover = CertificationPopover;
//# sourceMappingURL=CertificationPopover.js.map